<template>
  <main class="w-100">
    <form @submit.prevent="saveSubdivision">
      <div class="form-row">
        <div class="col-md-12 mx-3">
          <label for="subdivision">Dochterbedrijf</label>
          <select
              id="subdivision"
              class="form-control"
              @change="onChange()"
              v-model="subdivisionId">
            <option
                v-for="subdivision in availableSubdivisions" :key="subdivision.id"
                :value="subdivision.id">{{subdivision.name}}</option>
          </select>
        </div>
      </div>
      <div class="form-row">
        <div class="col-12 input-group justify-content-center">
          <div class="custom-control custom-switch">
            <input
                type="checkbox" class="custom-control-input"
                v-model="inheritWorkHours"
                id="inheritWorkHours"/>
            <label class="custom-control-label" for="inheritWorkHours">Werkuren van het moederbedrijf overnemen</label>
          </div>
        </div>
      </div>
      <div class="form-row">
        <button
            :disabled="submitDisabled"
            type="submit" class="btn-basic btn-green ml-2">
          Toevoegen
        </button>
      </div>
    </form>
  </main>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  name: "addSubdivisionComponent",
  data() {
    return {
      customerId: 0,
      subdivisionId: 0,
      submitDisabled: false,
      inheritWorkHours: false,
      originalCustomer: {},
    };
  },
  computed: {
    ...mapGetters({
      selectedCustomerDetail: "administrationCustomer/selectedCustomerDetail",
      availableSubdivisions: "administrationCustomer/availableSubdivisions"
    })
  },
  created() {
    this.customerId = this.selectedCustomerDetail.id;
    this.subdivisionId = this.availableSubdivisions[0].id;
    this.originalCustomer = this.selectedCustomerDetail;
  },
  methods: {
    ...mapMutations("administrationCustomer", ['setSelectedCustomerDetail']),
    ...mapActions("administrationCustomer", ['addSubdivisionToCustomer', 'updateSubdivisionWorkHours']),
    saveSubdivision() {
      const subdivision = this.availableSubdivisions.filter(subdivision => subdivision.id === this.subdivisionId)[0];
      this.addSubdivision();
      if (this.inheritWorkHours) this.updateWorkHours(subdivision);
    },
    onChange() {
      this.submitDisabled = this.subdivisionId <= 0;
    },
    addSubdivision() {
      const addSubdivisionDto = {
        parentId: this.customerId,
        subdivisionId: this.subdivisionId,
        inheritWorkHours: this.inheritWorkHours
      };

      this.addSubdivisionToCustomer(addSubdivisionDto);
      this.submitDisabled = true;
      this.subdivisionId = 0;
    },
    async updateWorkHours(subdivision) {
      const updateSubdivisionWorkHoursDto = {
        subdivisionId: subdivision.id,
        subdivision: {
          name: subdivision.name,
          abbreviation: subdivision.abbreviation,
          customerHours: {
            morning: this.selectedCustomerDetail.customerHours.morning,
            evening: this.selectedCustomerDetail.customerHours.evening,
            night: this.selectedCustomerDetail.customerHours.night
          },
          supervisor: {
            id: subdivision.supervisor.id,
            name: subdivision.supervisor.name,
            email: subdivision.supervisor.email
          },
        }
      };
      this.setSelectedCustomerDetail(subdivision);
      await this.updateSubdivisionWorkHours(updateSubdivisionWorkHoursDto);
      this.setSelectedCustomerDetail(this.originalCustomer);
    }
  }
};
</script>

<style scoped>
</style>